import React, { Suspense } from 'react';

// Conditional WebGL component - only renders if Three.js is available
let AnimatedBackgroundComponent = () => null;

try {
  const { Canvas, useFrame } = require('@react-three/fiber');
  const { useRef, useMemo } = React;
  const { SphereGeometry, MeshStandardMaterial } = require('three');

  function AnimatedSphere() {
    const mesh = useRef();

    useFrame((state) => {
      if (mesh.current) {
        mesh.current.rotation.x = state.clock.elapsedTime * 0.1;
        mesh.current.rotation.y = state.clock.elapsedTime * 0.15;
      }
    });

    return (
      <mesh ref={mesh} scale={3}>
        <sphereGeometry args={[1, 100, 200]} />
        <meshStandardMaterial
          color="#000000"
          opacity={0.03}
          transparent
          roughness={0}
          metalness={0}
        />
      </mesh>
    );
  }

  function FloatingParticles() {
    const particles = useMemo(() => {
      const count = 30;
      const positions = new Float32Array(count * 3);
      
      for (let i = 0; i < count * 3; i++) {
        positions[i] = (Math.random() - 0.5) * 20;
      }
      
      return positions;
    }, []);

    return (
      <points>
        <bufferGeometry>
          <bufferAttribute
            attach="attributes-position"
            count={particles.length / 3}
            array={particles}
            itemSize={3}
          />
        </bufferGeometry>
        <pointsMaterial size={0.15} color="#000000" opacity={0.15} transparent sizeAttenuation />
      </points>
    );
  }

  AnimatedBackgroundComponent = () => {
    return (
      <Canvas
        camera={{ position: [0, 0, 15], fov: 75 }}
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          pointerEvents: 'none',
          zIndex: 0,
        }}
        gl={{ alpha: true, antialias: true, powerPreference: 'high-performance' }}>
        <Suspense fallback={null}>
          <ambientLight intensity={0.5} />
          <AnimatedSphere />
          <FloatingParticles />
        </Suspense>
      </Canvas>
    );
  };
} catch (e) {
  // WebGL libraries not installed - component will render nothing
  console.warn('WebGL libraries not available. Run: npm install three @react-three/fiber');
}

export default AnimatedBackgroundComponent;
